<template>
  <div :class="floatLeft ? 'back-left' : 'default'">
    <el-button size="small" :type="btnType" @click="back">返回</el-button>
  </div>
</template>

<script>
export default {
  props: {
    pathOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    btnType: {
      type: String,
      default: ""
    },
    floatLeft: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    back() {
      if (Object.keys(this.pathOptions).length === 0) {
        this.$router.go(-1);
      } else {
        this.$router.push(this.pathOptions);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.default {
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
  
}
.back-left {
  float: left;
  // margin-top: 5px;
}
</style>